import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

// third-party
import { IntlProvider } from 'react-intl';

// project imports
import useConfig from 'hooks/useConfig';

const CLOUDFRONT_URL = import.meta.env.VITE_REMOTE_LOCALES_URL;

// Funzione di supporto per caricare le traduzioni locali
const loadLocalMessages = async (lang) => {
  try {
    // IMPORTANTE: Modifica questo percorso per puntare alla cartella
    // in cui si trovano effettivamente i tuoi file .json locali.
    const module = await import(`../utils/locales/${lang}.json`);
    return module.default;
  } catch (err) {
    console.error(`Errore critico: Impossibile caricare il fallback locale per ${lang}`, err);
    return {}; // Restituisce un oggetto vuoto per evitare crash
  }
};

// ==============================|| LOCALIZATION ||============================== //

export default function Locales({ children }) {
  const { i18n } = useConfig();

  const [messages, setMessages] = useState();

  useEffect(() => {
    const fetchTranslations = async () => {
      const localEnData = await loadLocalMessages('en');
      let enData = localEnData;
      let localeData = i18n !== 'en' ? await loadLocalMessages(i18n) : {};

      // 1. Tenta di caricare il file base in Inglese (en) da remoto, sopra il fallback locale
      try {
        const enResponse = await fetch(`${CLOUDFRONT_URL}/en.json`, {
          cache: 'no-store'
        });
        if (!enResponse.ok) throw new Error('Network response was not ok');
        enData = { ...localEnData, ...(await enResponse.json()) };
      } catch (err) {
        console.warn('Errore nel caricamento di en.json da CloudFront. Uso il fallback locale...', err);
      }

      // 2. Tenta di caricare la lingua selezionata (se diversa da en) da remoto, sopra il fallback locale
      if (i18n !== 'en') {
        try {
          const localeResponse = await fetch(`${CLOUDFRONT_URL}/${i18n}.json`, {
            cache: 'no-store'
          });
          if (!localeResponse.ok) throw new Error('Network response was not ok');
          localeData = { ...localeData, ...(await localeResponse.json()) };
        } catch (err) {
          console.warn(`Errore nel caricamento di ${i18n}.json da CloudFront. Uso il fallback locale...`, err);
        }
      }

      // 3. Unisce i messaggi base (en) con quelli della lingua specifica
      setMessages({ ...enData, ...localeData });
    };

    setMessages(undefined); // Mostra eventuali loader/skeleton
    fetchTranslations();

  }, [i18n]);

  // Se i messaggi non sono ancora caricati, potresti voler renderizzare un loader
  if (!messages) return null;

  return (
      <IntlProvider locale={i18n} defaultLocale="en" messages={messages}>
        {children}
      </IntlProvider>
  );
}

Locales.propTypes = { children: PropTypes.node };